import { Menu } from "@greeter/core";
import { mockProduct } from "./MockProduct";

export const mockMenu: Menu = {
  categories: [
    { id: "1", name: "Drinks", priority: 0 },
    { id: "2", name: "Bordpakker", priority: 0 },
  ],
  products: [
    {
      ...mockProduct,
      id: "1",
      categories: ["1"],
      priceChanges: [],
      originalPrice: mockProduct.price,
      active: true,
    },
    {
      ...mockProduct,
      id: "2",
      categories: ["2"],
      priceChanges: [],
      originalPrice: mockProduct.price,
      active: true,
    },
  ],
  featuredCategoryId: "1",
};
